import { fragmentMemberKey } from '../../../domain/quoteSourceFragment';
import type { QuoteItem } from './types';

/** Source and selected replacement equipment have independent revision tuples. */
export function quoteContainerEquipmentSourceRevision(
  item: QuoteItem,
): string | undefined {
  return (
    (item.sourceType === 'device' ? item.sourceRevisionId : undefined) ??
    item.originalDeviceIdentity?.deviceRevisionId ??
    item.formalPlanOccurrence?.deviceRevisionId ??
    item.deviceFieldSnapshot?.deviceRevisionId
  );
}

export function quoteContainerSourceMemberKey(item: QuoteItem): string {
  if (item.sourceType !== 'device') return fragmentMemberKey(item);
  const revision = quoteContainerEquipmentSourceRevision(item);
  if (!revision || item.sourceId !== item.deviceId)
    throw new Error('套餐设备缺少准确来源修订');
  return `equipment:${item.deviceId}:revision:${revision}`;
}
